import { Box, BoxProps, Center } from '@chakra-ui/layout';
import { Spinner } from '@chakra-ui/react';
import { NoData } from './NoData';
import React from 'react';
import _ from 'lodash';

interface ListViewChildProps<Data> {
  data: Data[];
}

type ListViewProps<Data> =
  | {
      data: Data[] | null | undefined;
      search: string;
      searchFields(d: Data): string[];
      children?: (props: ListViewChildProps<Data>) => React.ReactNode;
      render?: never;
      isLoading?: boolean;
      orderBy?:
        | ((d: Data) => unknown)
        // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
        | ((d: Data) => unknown | string)[]
        | string
        | string[];
      reorderOn?: unknown[];
    }
  | {
      data: Data[] | null | undefined;
      search: string;
      searchFields(d: Data): string[];
      render: (props: ListViewChildProps<Data>) => React.ReactNode;
      children?: never;
      isLoading?: boolean;
      orderBy?:
        | ((d: Data) => string | number)
        | ((d: Data) => string | number | string[])[]
        | string
        | number
        | string[]
        | number[];

      reorderOn?: unknown[];
    };

type ListViewPropsType<Data> = ListViewProps<Data> & BoxProps;

export function ListView<Data>({
  data: propData,
  search,
  searchFields,
  isLoading,
  orderBy,
  render,
  children,
  ...props
}: ListViewPropsType<Data>) {
  const data = React.useMemo(() => {
    const d = !search
      ? propData
      : propData?.filter((d) =>
          searchFields(d)
            .map((sf) => sf.toLowerCase().includes(search.toLowerCase()))
            .reduce((c, n) => c || n, false),
        );
    if (orderBy) {
      return _.orderBy(d, orderBy);
    }
    return d ?? [];
  }, [search, propData, orderBy]);

  if (isLoading) {
    return (
      <Center w="full" h="full">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (!propData?.length) {
    return <NoData />;
  }

  if (render) {
    return (
      <Box width="100%" {...(props ?? {})}>
        {render({ data })}
      </Box>
    );
  }

  return <Box {...(props ?? {})}>{children?.({ data })}</Box>;
}
